import React from 'react';
import {useSelector} from 'react-redux';

import {
    Layout,
} from 'antd';
import Goftino from './components/Goftino';

function AppClearLayout({children}) {
    const {Content} = Layout;
    const ThemeState = useSelector(state => state.Theme)

    return <Layout className={`layout clear-layout ${ThemeState.theme}-theme`}>
        <Content>
            {children}
        </Content>
        <Goftino open={ThemeState.showSupportDrawer}/>
    </Layout>
}

export default AppClearLayout